import { Icon, Text } from '@fluentui/react';
import { useTheme } from '../../../../../../../Themes/themeContext';
import { useSortContext } from '../../context/SortContext';
import { useCallback } from 'react';
import { PagedRequestSortOptions, SortDirection, SortType } from '../../../../../../../api/generated/data-contracts';

export const TableHeader = ({ children, index }: { children: string; index: number }) => {
    const theme = useTheme();
    const { setSort } = useSortContext();
    const onClick = useCallback(() => {
        setSort(currentSort => {
            let direction = SortDirection.Descending;
            if (currentSort?.type === SortType.Period && currentSort?.key === index && currentSort?.direction === SortDirection.Descending) {
                direction = SortDirection.Ascending;
            }
            return { direction, key: index, type: SortType.Period } as PagedRequestSortOptions;
        });
    }, [index, setSort]);
    return (
        <div
            onClick={onClick}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', cursor: 'pointer', userSelect: 'none' }}
        >
            <Text styles={{ root: { color: theme.semanticColors.bodyText, fontSize: 15, fontWeight: 600 } }}>
                {children}
                <ColumnSortIcon index={index} />
            </Text>
        </div>
    );
};

const ColumnSortIcon = ({ index }: { index: number }) => {
    const { sort } = useSortContext();
    if (!sort || sort.key !== index) {
        return null;
    }
    return <Icon iconName={sort.direction === SortDirection.Ascending ? 'SortUp' : 'SortDown'} />;
};
